export const organizationUsers = [
  {
    fullName: 'Joe CoreAdministrator',
    id: 1,
    firstName: 'Joe',
    lastName: 'CoreAdministrator',
    email: 'organization@bmiq.com',
    isTestUser: false,
    organizationId: 1,
    'user.id': 2,
    'user.user_detail.id': 2,
  },
];

export const createOrganizationUser = {
  email: 'drryanjames@bmiq.com',
  firstName: 'Ryan',
  lastName: 'James',
  isTestUser: false,
  organizationId: 1,
};
